import React from 'react';

import {
  firmContactTypeLabels,
  firmContactTypeOptions,
} from '../../../../types/domain/firm/constants';
import {
  recordStatusLabels,
  recordStatusOptions,
} from '../../../../types/domain/record-status/constants';
import { StyledSelectField, StyledTextInputField } from './inputs/RecordInputs.styles';

/**
 * The column configuration for the Firm Contacts Record Table
 */
export const getFirmContactColumns = () => [
  {
    field: 'type',
    headerName: 'Type',
    editCellRendererFramework: (row, disabled) => (
      <StyledSelectField name="type" options={firmContactTypeOptions} disabled={disabled} />
    ),
    cellRendererFramework: row => firmContactTypeLabels[row.type],
  },
  {
    field: 'value',
    headerName: 'Contact',
    editCellRendererFramework: (row, disabled) => (
      <StyledTextInputField name="value" disabled={disabled} />
    ),
  },
  {
    field: 'recordStatus',
    headerName: 'Status',
    editCellRendererFramework: (row, disabled) => (
      <StyledSelectField name="recordStatus" options={recordStatusOptions} disabled={disabled} />
    ),
    cellRendererFramework: row => recordStatusLabels[row.recordStatus],
  },
];
